import { Module } from 'vuex';

import { Optional, RootState } from 'frontend/types';
import {
  LessonAsset,
  LessonAssetAliasMap,
  LessonSummary,
  JSONConfigAsset,
} from 'frontend/types/lessons/editor';
import { extractAssetsFromLessonSource } from 'frontend/views/lessons/editor/utils';
import { postData } from 'frontend/utils/ajax';
import { apiResolve } from 'frontend/router';

interface LessonVersionsState {
  lessonVersions: LessonSummary[];
}

const lessonVersions: Module<LessonVersionsState, RootState> = {
  namespaced: true,
  state: {
    lessonVersions: [],
  },

  mutations: {
    setValue(state: LessonVersionsState, value: LessonSummary[]) {
      state.lessonVersions = value;
    },
  },

  getters: {
    lessonAssets(state: LessonVersionsState): LessonAssetAliasMap {
      const lessonAssets: LessonAssetAliasMap = {};
      state.lessonVersions.forEach(version => {
        if (version.lesson_source) {
          const assets = extractAssetsFromLessonSource(version.lesson_source);
          assets.forEach(asset => {
            if (!lessonAssets[asset.alias]) {
              lessonAssets[asset.alias] = [];
            }
            lessonAssets[asset.alias].push({
              asset,
              lessonVersion: version.version_name,
              state: version.state,
              createdByName: version.created_by_name,
              ownedByName: version.owned_by_name,
              createdTs: version.created_ts,
              internalChangeReason: version.internal_change_reason,
              lastModifiedTs: version.last_modified_ts,
            });
          });
        }
      });
      return lessonAssets;
    },

    getLessonVersion(state: LessonVersionsState): (versionName: string) => Optional<LessonSummary> {
      return versionName => {
        return state.lessonVersions.find(v => versionName === v.version_name);
      };
    },
  },
};

export default lessonVersions;
